export default function IconCanceled({color = "white", size = 24}) {
    return (
        <svg
            width={size + 1}
            height={size}
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M3.75 11.75L11.25 4.25M3.75 4.25L11.25 11.75" stroke={color} strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}
